<template>
  <div class="cta-box">
    <div class="cta-content">
      <div class="cta-left">
        <img src="/images/osmanlicaicon.png" alt="icon" class="cta-icon" />
        <div>
          <h3 class="cta-title">{{ $t('cta.title') }}</h3>
          <p class="cta-subtitle">{{ $t('cta.subtitle') }}</p>
        </div>
      </div>
      <div class="cta-buttons">
        <button class="btn-primary" @click="handleOrderClick">{{ $t('cta.uploadNow') }}</button>
        <button class="btn-secondary" @click="handleContactClick">{{ $t('cta.contact') }}</button>
      </div>
    </div>

    <!-- Login Popup -->
    <LoginPopup v-if="showLoginPopup" @success="onLoginSuccess" @close="showLoginPopup = false" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import LoginPopup from '@/components/LoginPopup.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const showLoginPopup = ref(false)
const isAuthenticated = computed(() => !!localStorage.getItem('token'))

function handleOrderClick() {
  if (isAuthenticated.value) {
    router.push('/panel/user')
  } else {
    showLoginPopup.value = true
  }
}

function onLoginSuccess() {
  showLoginPopup.value = false
  router.push('/panel/user')
}

function handleContactClick() {
  const phone = '+905015713333'
  const message = encodeURIComponent(t('cta.contactMessage'))
  window.open(`https://wa.me/${phone}?text=${message}`, '_blank')
}
</script>

<style scoped>

.cta-box {
  background-color: #2d4e5788;
  color: white;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  max-width: 800px;
  width: calc(100% - 40px);
  margin: 0 auto;
  margin-top: 0px;
  border-radius: 0;
  position: relative;
  
}

  
  .cta-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 20px;
    flex-wrap: wrap;
  }
  
  .cta-left {
    display: flex;
    align-items: center;
    gap: 15px;
    flex: 1;
  }
  
  .cta-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    transform: scale(2);
    object-fit: cover;
  }
  
  .cta-title {
  font-weight: bold;
  margin: 0;
  font-size: 16px;
  
}
  
  .cta-subtitle {
    font-size: 14px;
    opacity: 0.8;
    margin: 0;
    color: rgb(255, 251, 0); /* Turuncumsu vurgu rengi */
  }
  
  .cta-buttons {
    display: flex;
    gap: 10px;
    color: #f39c12; /* Turuncumsu vurgu rengi */
  }
  
  .btn-primary {
    background-color: #e74c3c;
    color: white;
    padding: 10px 16px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    border: none;
  }
  
  .btn-primary:hover {
    background-color: #c0392b;
  }
  
  .btn-secondary {
    background-color: transparent;
    color: white;
    border: 2px solid white;
    padding: 10px 16px;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
  }
  
  .btn-secondary:hover {
    background-color: rgb(166, 255, 0);
    color: #1f3b4d;
  }

  @media (max-width: 640px) {
  .cta-box {
    flex-direction: column;
    padding: 16px 20px;
    bottom: 3%;
  }

  .cta-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .cta-buttons {
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;
  }
}
  </style>
  